export const COMMENTS_FIELD = 'comments';
export enum EmployeeStatus {
  Done = 'DONE',
}
